import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

const companyCode = getCompanyCodeFromToken();

export const SaveCandidate = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Candidates/AddCandidate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const GetCandidateByRequestId = async (Request_id) => {
  try {
    const response = await fetch(`${API_URL}Candidates/GetCandidateByRequestId/${Request_id}`);
    if (!response.ok) throw new Error("Failed to fetch candidates");
    return await response.json();
  } catch (error) {
    console.error("Error fetching candidates:", error);
    return [];
  }
};

export const fetchCandidateDetails = async (id) => {
  try {
    const response = await fetch(`${API_URL}Candidates/FetchCandidateDetails/${id}`);
    if (!response.ok) throw new Error("Failed to fetch candidate details");
    return await response.json();
  } catch (error) {
    console.error("Error fetching candidate details:", error);
    return [];
  }
};

export const GetCandidate = async () => {
  try {
    const response = await fetch(`${API_URL}Candidates/GetCandidate/${companyCode}`);
    if (!response.ok) throw new Error("Failed to fetch candidates");
    return await response.json();
  } catch (error) {
    console.error("Error fetching candidates:", error);
    return [];
  }
};

export const getCandidateApprovalFlow = async (candidateId) => {
  try {
    const response = await fetch(`${API_URL}Approvals/candidate/${candidateId}/approval-flow`);
    if (!response.ok) throw new Error("Failed to fetch approval flow");
    return await response.json();
  } catch (error) {
    console.error("Error fetching approval flow:", error);
    return [];
  }
};

export const UpdateCandidateStaus = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Candidates/UpdateCandidateStaus`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update candidate status');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UploadDocuments = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Candidates/UploadDocuments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateCandidate = async (requestBody) => {
  try {
    const response = await fetch(`${API_URL}Candidates/UpdateCandidate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
